// src/data/directoryConstants.js
// Shared constants for the practitioner Directory (filters, etc.).
// Kept separate from modalityTaxonomy.js, which is a governed modality-only file.

// Session format options for the directory's Format filter. Values must match
// the chip labels derived in src/utils/practitionerDirectoryMapper.js
// (serviceType → 'Virtual' / 'In-Person').
export const SESSION_FORMATS = ['Virtual', 'In-Person'];
